// extracted by mini-css-extract-plugin
module.exports = {"navWrapper":"jQ","overlay":"jR"};